import type { PiwikTracker } from './types/piwidk'

export function loadScript() {
  // check if is already initialized
  if ('_paq' in window)
    return

  const {
    AUTOBID_TRACKING: { HOST, SITE_ID, DISABLE, CONTAINER_PATH },
  } = useRuntimeConfig().public

  if (!HOST || !SITE_ID || Number(DISABLE))
    return

  if (CONTAINER_PATH.length) {
    const _mtm = (window._mtm = window._mtm || [])
    _mtm.push({ 'mtm.startTime': new Date().getTime(), 'event': 'mtm.Start' })
  }
  else {
    const { status, data: sessionData } = useAuth()
    const _paq = [
      ['trackPageView'],
      ['enableLinkTracking'],
      ['setTrackerUrl', `//${HOST}/matomo.php`],
      ['setSiteId', SITE_ID],
    ]

    if (status.value === 'authenticated' && sessionData.value?.user?.id) {
      _paq.push(['setUserId', String(sessionData.value.user.id)])
    }

    window._paq = _paq
  }

  const script = document.createElement('script')
  script.setAttribute('async', 'true')
  script.setAttribute(
    'src',
    `//${HOST}/${CONTAINER_PATH.length ? CONTAINER_PATH : 'matomo.js'}`,
  )
  document.head.appendChild(script)
}

export function getMatomo(): PiwikTracker | null {
  if ('Piwik' in window && window.Piwik && 'getAsyncTracker' in window.Piwik) {
    return window.Piwik.getAsyncTracker()
  }

  return null
}
